import styled from "styled-components"
import { usePassenger } from "../../../context/passenger"

export default function Instructions() {
    const { setInstructionsGiven } = usePassenger()
    return (
        <Main>
            <Logo>
                <img src="/assets/logo.png" alt="" />
            </Logo>
            <Text>
                <h1>Welcome to Molantur!</h1>
                <p>
                &bull; En esta página podrás verificar tus datos y la fecha de tus tours, en 
                la siguente pagina podrás revisar tus datos y actualizarlos, cada que los 
                cambies se enviaran a administracion para autorizar el cambio y que 
                sepamos qué se modifico, los cambios toman aproximadamente de 4 a 6 
                horas en aprobarse por lo tanto te recomendamos no hacer cambios de 
                ultimo minuto o fuera de horario de atención de la agencia.
                </p>
                <p>
                &bull; Si necesitas hacer un cambio inmediato por favor comunicate a 
                nuestro numero de emergencia: +56 9 7577 4192 el cual proporciona
                atención de Lunes a Domingo de 10:00 a 21:00 horas. Si tienes 
                alguna emergencia en algún tour de mañana por favor llamanos 
                (por llamada normal no whatsapp al mismo número). 
                </p>
            </Text>
            <Button onClick={() => {
                setInstructionsGiven(true)
                localStorage.setItem('instructionsGiven', 'true')
                }}>Continue</Button>
        </Main>
    )
}

const Main = styled.div`
max-width: 700px;
width: 80%;
margin: auto;
display: flex;
flex-direction: column;
align-items: center;
gap: 20px;
`

const Logo = styled.div`
height: 300px;
width: 100%;
display: flex;
justify-content: center;
align-items: center;
img {
    height: 100%;
    width: auto;
}
`

const Text = styled.div`
width: 100%;
text-align: justify;
h1 {
    font-size: 24px;
    margin-bottom: 20px;
    text-align: center;
}
p {
    font-size: 18px;
}
`

const Button = styled.button`
margin: auto;
display: inline-block;
padding: 0 10px;
height: 2.6em;
line-height: 2.5em;
`